module.exports = "/images/vendor/lightbox2/dist/next.png?31f15875975aab69085470aabbfec802";